import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { getCurrentLanguage, State } from '../../../shared/standalone-packages/ecap3/core';

@Component({
    selector: 'app-pcx-day-picker',
    templateUrl: './pcx-day-picker.component.html',
    styleUrls: ['./pcx-day-picker.component.scss'],
    standalone: false
})
export class PcxDayPickerComponent implements OnDestroy {
    @Input() control: FormControl | AbstractControl;
    @Input() label: string;
    @Input() index: number = 0;
    @Input() customClass: string;
    @Input() showClearButton = false;
    @Input() minDate: Date = new Date(1971, 1, 1);
    @Input() maxDate = new Date(2050, 1, 1);
    @Input() required: boolean = false;
    @Input() labelClass: boolean = false;
    @Input() appearance: string = 'outline';
    @Output() dateChanged = new EventEmitter();

    currentLanguage: Observable<string>;
    destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private dateAdapter: DateAdapter<any>,
        private store: Store<State>
    ) {
        this.setLanguage();
    }

    private setLanguage(): void {
        this.currentLanguage = this.store.select(getCurrentLanguage);
        this.currentLanguage.pipe(takeUntil(this.destroy$)).subscribe(lang => {
            this.dateAdapter.setLocale(lang);
        });
    }

    public dateChange(event: any) {
        this.dateChanged.emit(event.value);
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
